import heydoctor from 'app/vendor/heydoctor';
import {
  DiagnoseBody,
  DiagnoseResponse,
  SuggestBlock,
  SuggestBody,
  SearchResponse,
  DiagnoseCondition,
} from 'app/types/Infermedica';
import { ServiceModel } from '@goodrx/heydoctor-core';

type InfermedicaSessionId = { sessionId: string };

export const startSession = async () => {
  const {
    data: { data },
  } = await heydoctor.client.http.post<{ data: { sessionId: string } }>('/triage/start');
  return data;
};

export const suggest = async (body: SuggestBody & InfermedicaSessionId) => {
  const {
    data: { data },
  } = await heydoctor.client.http.post<{ data: SuggestBlock[] }>('/triage/symptoms/suggest', body);
  return data;
};

export const diagnose = async (body: DiagnoseBody & InfermedicaSessionId) => {
  const {
    data: { data },
  } = await heydoctor.client.http.post<{ data: DiagnoseResponse }>('/triage/diagnosis', body);

  return data;
};

export const qualify = async (body: { conditions: DiagnoseCondition[]; state: string } & InfermedicaSessionId) => {
  const {
    data: { data },
  } = await heydoctor.client.http.post<{
    data: { service: ServiceModel | null; matchingCondition: DiagnoseCondition | null };
  }>(`/triage/qualification`, body);

  return data;
};

export const search = async (body: { phrase: string } & InfermedicaSessionId) => {
  const {
    data: { data },
  } = await heydoctor.client.http.post<{ data: SearchResponse[] }>(`/triage/symptoms/search`, body);

  return data;
};
